export const HOME = '/';
export const TOURNAMENT_LISTING = '/';
export const LEAGUE_LISTING = '/leagues';
export const LOGIN_STRING = 'login';
export const LOGIN = `/${LOGIN_STRING}`;
export const NOT_FOUND = '/404-not-found';
export const LEAGUES = 'leagues';
export const LEAGUE_STRING = 'league';
export const TOURNAMENT_STRING = 'tournament';
export const TOURNAMENT_LEAGUES_STRING = window.location.pathname.toLowerCase().includes('/leagues')
  ? `${LEAGUES}/${LEAGUE_STRING}`
  : 'tournament';
export const TOURNAMENT_LEAGUE = `/${TOURNAMENT_LEAGUES_STRING}/:tournamentId`;
export const OVERVIEW_PART = 'overview';
export const OVERVIEW = `${TOURNAMENT_LEAGUE}/${OVERVIEW_PART}`;
export const PLAYERS_PART = 'players';
export const PLAYERS = `${TOURNAMENT_LEAGUE}/${PLAYERS_PART}`;
export const TEAMS_PART = 'teams';
export const TEAMS = `${TOURNAMENT_LEAGUE}/${TEAMS_PART}`;
export const TEAM_PART = `:teamId`;
export const TEAM = `${TEAMS}/${TEAM_PART}`;
export const EVENTS_PART = 'events';
export const EVENTS = `${TOURNAMENT_LEAGUE}/${EVENTS_PART}`;
export const EVENT_PART = `:eventId`;
export const EVENT = `${EVENTS}/${EVENT_PART}`;
export const DRAWS_PART = 'draws';
export const DRAWS = `${EVENT}/${DRAWS_PART}`;
export const DRAW_PART = ':drawId';
export const DRAW = `${DRAWS}/${DRAW_PART}`;
export const SCHEDULE_PART = 'schedule';
export const SCHEDULE = `${TOURNAMENT_LEAGUE}/${SCHEDULE_PART}`;
export const AUTO_SCHEDULE_STRING = 'auto-schedule';
export const AUTO_SCHEDULE = `${AUTO_SCHEDULE_STRING}`;
export const MATCHES_PART = 'matches';
export const MATCHES = `${TOURNAMENT_LEAGUE}/${MATCHES_PART}`;
export const REPORTS_PART = 'reports';
export const REPORTS = `${TOURNAMENT_LEAGUE}/${REPORTS_PART}`;
export const FACILITIES_STRING = 'facilities';
export const FACILITIES = `${SCHEDULE}/${FACILITIES_STRING}`;
export const ADD_FACILITY_STRING = `add-facility`;
export const ADD_FACILITY = `${SCHEDULE}/${FACILITIES_STRING}/${ADD_FACILITY_STRING}`;
export const EDIT_FACILITY_STRING = `edit-facility`;
export const EDIT_FACILITY = `${SCHEDULE}/${FACILITIES_STRING}/:venueId/${EDIT_FACILITY_STRING}`;
export const COURT_CONFIG_STRING = 'court-config';
export const COURT_CONFIG = `${SCHEDULE}/${FACILITIES_STRING}/:venueId/${COURT_CONFIG_STRING}`;
export const SCHEDULE_SETTINGS_STRING = `settings`;
export const SCHEDULE_SETTINGS = `${SCHEDULE}/${SCHEDULE_SETTINGS_STRING}`;
export const LINKED_TOURNAMENTS_STRING = 'linked-tournaments';
export const LINKED_TOURNAMENTS = `${LINKED_TOURNAMENTS_STRING}`;
export const PARTICIPANTS_STRING = 'participants';

// Safe Play routes
export const SAFE_PLAY_STRING = 'safe-play';
export const SAFE_PLAY_PENDING_STRING = 'pending';
export const SAFE_PLAY_EXPIRED_STRING = 'expired';
export const SAFE_PLAY_NOT_STARTED_STRING = 'not-started';
export const SAFE_PLAY_NOT_APPROVED_STRING = 'not-approved';

export const SAFE_PLAY = `/${SAFE_PLAY_STRING}`;
export const SAFE_PLAY_PENDING = `${SAFE_PLAY}/${SAFE_PLAY_PENDING_STRING}`;
export const SAFE_PLAY_EXPIRED = `${SAFE_PLAY}/${SAFE_PLAY_EXPIRED_STRING}`;
export const SAFE_PLAY_NOT_STARTED = `${SAFE_PLAY}/${SAFE_PLAY_NOT_STARTED_STRING}`;
export const SAFE_PLAY_NOT_APPROVED = `${SAFE_PLAY}/${SAFE_PLAY_NOT_APPROVED_STRING}`;

export const TAB_OVERVIEW = 'overview';
export const TAB_PARTICIPANTS = 'participants';
export const TAB_EVENTS = 'events';
export const TAB_MATCHES = 'matches';
export const TAB_SCHEDULE = 'schedule';
export const TAB_REPORTS = 'reports';
export const TAB_RESOURCES = 'resources';

export const TAB_SETTINGS = 'settings';
export const TAB_WEBPUBLIC = 'webpublic';
